import React, { useEffect, useState } from 'react';
import logo from '../logo.svg';

export default function InitialLanding({ onGoogleLogin }) {
  const [googleError, setGoogleError] = useState(null);
  const hasClientId = Boolean(process.env.REACT_APP_GOOGLE_CLIENT_ID);

  useEffect(() => {
    if (!hasClientId) {
      return;
    }

    let cancelled = false;
    const container = document.getElementById('google-signin-button');
    if (!container) {
      return;
    }

    const initializeGoogle = () => {
      if (cancelled || !window.google || !window.google.accounts || !window.google.accounts.id) {
        return false;
      }
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: async (resp) => {
          const credential = resp && resp.credential;
          if (!credential || !onGoogleLogin) {
            return;
          }
          try {
            await onGoogleLogin(credential);
            setGoogleError(null);
          } catch (err) {
            setGoogleError((err && err.message) || 'Google sign-in failed');
          }
        },
      });
      container.innerHTML = '';
      window.google.accounts.id.renderButton(container, {
        theme: 'filled_blue',
        size: 'large',
        width: 320,
        text: 'continue_with',
        shape: 'rectangular',
      });
      return true;
    };

    const waitForGoogleAndInit = () => {
      if (initializeGoogle()) {
        return;
      }
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (cancelled) {
          window.clearInterval(timer);
          return;
        }
        if (initializeGoogle()) {
          window.clearInterval(timer);
          return;
        }
        if (attempts >= 50) {
          window.clearInterval(timer);
          setGoogleError('Google Sign-In did not initialize');
        }
      }, 100);
    };

    const existing = document.querySelector('script[data-google-identity="1"]');
    if (existing) {
      waitForGoogleAndInit();
    } else {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.setAttribute('data-google-identity', '1');
      script.onload = waitForGoogleAndInit;
      script.onerror = () => {
        if (!cancelled) {
          setGoogleError('Failed to load Google Sign-In');
        }
      };
      document.head.appendChild(script);
    }

    return () => {
      cancelled = true;
    };
  }, [hasClientId, onGoogleLogin]);

  return (
    <div className="auth-floating-wrap auth-welcome-stack mx-auto text-center">
      <div className="auth-welcome-heading">
        <img className="auth-logo" src={logo} alt="Flique" />
        <p className="auth-welcome-tagline px-2">
          Log films, rank them, and compare your taste with friends.
        </p>
      </div>
      {hasClientId ? (
        <>
          <div className="auth-google-slot d-flex justify-content-center">
            <div id="google-signin-button" />
          </div>
          {googleError && (
            <p className="auth-welcome-error small mb-0 px-2">{googleError}</p>
          )}
        </>
      ) : (
        <p className="auth-welcome-missing-client small mb-0 px-3">
          Set <code className="user-select-all">REACT_APP_GOOGLE_CLIENT_ID</code> in{' '}
          <code>.env</code> to enable sign-in.
        </p>
      )}
    </div>
  );
}
